/** @format */

import * as React from 'react';
//@ts-ignore
import { StyleSheet, View } from 'react-native';
//@ts-ignore
import { JDLoadingView, JDDevice } from '@jdreact/jdreact-core-lib';
const styles = StyleSheet.create({
  loading: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
  },
});
const Loading = () => {
  return (
    <View style={styles.loading}>
      <JDLoadingView></JDLoadingView>
    </View>
  );
};

export default Loading;
